<template>
  <!-- Navigation -->
  <nav class="navbar navbar-light bg-light static-top">
    <div class="container">
      <span class="navbar-brand-wrapper">
        <router-link class="navbar-brand" :to="{name: 'home'}"><img src="../assets/images/logo.png" width="223" height="54" alt="印刷工場のための深層学習モデル作成ツール POODL プードル" /></router-link>
        <!-- <span class="navbar-subtitle"><b>プルーフロッグ</b><br>デザインデータのバージョン管理Webツール</span> -->
      </span>
      <div class="top-menu">
        <ul>
          <!-- <li><router-link :to="{ name: 'feature' }">機能</router-link></li> -->
          <li><router-link :to="{ name: 'pricing' }">料金</router-link></li>
          <li><a href="http://help.poodl.cloud/support/home" target="_blank" class="target-blank">ヘルプ</a></li>
        </ul>
      </div>
      <div class="top-button-wrapper">
        <!-- <el-tooltip placement="bottom">
          <div slot="content" effect="light">
            3月までのご登録で先着1000名様に無料でご利用いただけるキャンペーン実施中！
          </div>
          <a :href="signupUrl" class="btn btn-lg btn-info trial-button">無料トライアル</a>
        </el-tooltip> -->
        <!-- <a :href="signupUrl" class="btn btn-lg btn-info trial-button">無料トライアル</a> -->
        <!-- <a :href="appUrl" class="btn btn-lg login-button">ログイン</a> -->
        <router-link :to="{ name: 'contact' }"><el-button class="btn btn-lg btn-info">お問い合わせ</el-button></router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import config from '../config';

export default {
  name: 'Top',
  props: {
  },
  computed: {
    appUrl() {
      return config.appUrl;
    },
    // signupUrl() {
    //   return config.appUrl + '/signup';
    // }
  },
  methods: {
    handleContact() {
      if (this.$intercom) {
        this.$intercom.show();
        return;
      }
      window.open('https://taktpixel.co.jp', '_blank');
    },
  }
}
</script>

<style scoped lang="scss">
nav {
  background: url('../assets/images/image003.jpg') no-repeat center center;
}
.navbar-brand-wrapper {
  .navbar-brand {
    float: left;
  }
  .navbar-subtitle {
    font-size: 1rem;
    vertical-align: bottom;
    line-height: 1.5rem;
    display: inline-block;
    text-align: left;
    margin: 0.5rem 0;
  }
}

.top-menu {
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      display: inline-block;
      margin: 0 20px;
      line-height: 55px;
      vertical-align: middle;
      font-size: 1.6rem;
      a {
        text-decoration: none;
      }
      a:hover, a:active {
        text-decoration: underline;
      }
    }
  }
}


.trial-button {
  margin-right: 20px;
}

.login-button {
  background: #f0f0f0;
}
// .navbar-brand {
//   background-image: url('../assets/images/logo.png');
//   background-size: 223px 54px;
//   height: 54px;
//   width: 223px;
// }
// .navbar-brand, .navbar-brand:hover, .navbar-brand:active, .navbar-brand:focus {
//   color: transparent;
// }

a.target-blank {

}
</style>
